import React, { useContext } from 'react'

import { ProfileOverview } from '../../fragments/ProfileOverview'
import { ActivityTimeline } from '../../fragments/profile-modules/ActivityTimeline'
import { ConversionFunnel } from '../../fragments/profile-modules/ConversionFunnel'
import { ActivitySummary } from '../../fragments/profile-modules/ActivitySummary'
import { Recommendation } from '../../fragments/profile-modules/Recommendation'
import { Contact } from '../../fragments/profile-modules/Contact'
import { CustomerAI } from '../../fragments/profile-modules/CustomerAI'
import { CustomerSatisfaction } from '../../fragments/profile-modules/CustomerSatisfaction'
import { Kiosk } from '../../fragments/profile-modules/Kiosk'
import { ProcessFlow } from '../../fragments/profile-modules/ProcessFlow'
import { ProfileUpdate } from '../../fragments/profile-modules/ProfileUpdate'
import { JourneyTrigger } from '../../fragments/profile-modules/JourneyTrigger'
import { RootContext } from '../../root/RootContext'
import { WrapperComponent } from '../../utilities/components'

import './Home.scss'

export default function Home() {
  const { project } = useContext(RootContext)
  //use default module ordering
  const modules = project.modules
  let newModule = [...modules]

  return (
    <div
      className='home-wrapper'
      style={{
        backgroundColor: project.branding.backgroundColor,
        color: project.branding.primaryTextColor,
        fontFamily: project.branding.bodyFont,
      }}
    >
      <div className='left-rail'>
        <ProfileOverview />
      </div>
      <div className='modules-wrapper'>
        <div className='scroll-wrapper'>
          {newModule.map((module, index) => (
            <div key={`module-${index}`}><WrapperComponent {...module} /></div>
          ))}
        </div>
      </div>
    </div>
  )
}
